/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliveryWindow
 */
export interface DeliveryWindow {
    /**
     * 
     * @type {string}
     * @memberof DeliveryWindow
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof DeliveryWindow
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof DeliveryWindow
     */
    end: Date;
}

/**
 * Check if a given object implements the DeliveryWindow interface.
 */
// @ts-ignore
export function instanceOfDeliveryWindow(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "start" in value;
    isInstance = isInstance && "end" in value;

    return isInstance;
}

// @ts-ignore
export function DeliveryWindowFromJSON(json: any): DeliveryWindow {
    return DeliveryWindowFromJSONTyped(json, false);
}

// @ts-ignore
export function DeliveryWindowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryWindow {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
    };
}

// @ts-ignore
export function DeliveryWindowToJSON(value?: DeliveryWindow | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'start': (value.start.toISOString()),
        'end': (value.end.toISOString()),
    };
}

